import Cookies from 'js-cookie';

const state = {
    remember_account: Cookies.get('remember_account') || '',
    username: Cookies.get('username') || '',
    is_superuser: Cookies.get('is_superuser') || '',
    first_name: Cookies.get('first_name') || '',
    last_name: Cookies.get('last_name') || '',
    email: Cookies.get('email') || '',
    phone_number: Cookies.get('phone_number') || '',
    is_stuff: Cookies.get('is_stuff') || '',
    is_fitter: Cookies.get('is_fitter') || '',
    is_manager: Cookies.get('is_manager') || '',
    is_engineer: Cookies.get('is_engineer') || '',
    abonent: Cookies.get('abonent') || '',
    date_joined: Cookies.get('date_joined') || '',
};

const mutations = {
    SET_ACCOUNT(state, data) {
        if (data.remember_account){
            state.remember_account = data.remember_account;
            Cookies.set('remember_account', data.remember_account);
        }
        state.username = data.username;
        Cookies.set('username', data.username, { expires: 7 }); // expires in 7 days

        state.is_superuser = data.is_superuser ? 'true' : 'false';
        Cookies.set('is_superuser', data.is_superuser, { expires: 7 });

        state.first_name = data.first_name;
        Cookies.set('first_name', data.first_name, { expires: 7 });

        state.last_name = data.last_name;
        Cookies.set('last_name', data.last_name, { expires: 7 });

        state.email = data.email;
        Cookies.set('email', data.email, { expires: 7 });

        state.phone_number = data.phone_number;
        Cookies.set('phone_number', data.phone_number, { expires: 7 });

        state.is_stuff = data.is_stuff ? 'true' : 'false';
        Cookies.set('is_stuff', data.is_stuff, { expires: 7 });

        state.is_manager = data.is_manager ? 'true' : 'false';
        Cookies.set('is_manager', data.is_manager, { expires: 7 });

        state.is_engineer = data.is_engineer ? 'true' : 'false';
        Cookies.set('is_engineer', data.is_engineer, { expires: 7 });

        state.is_fitter = data.is_fitter ? 'true' : 'false';
        Cookies.set('is_fitter', data.is_fitter, { expires: 7 });

        state.abonent = data.abonent;
        Cookies.set('abonent', data.abonent, { expires: 7 });

        state.date_joined = data.date_joined;
        Cookies.set('date_joined', data.date_joined, { expires: 7 });
    },

    DELETE_DATA(state) {
        state.remember_account = null;
        Cookies.remove('remember_account');

        state.username = null;
        Cookies.remove('username');

        state.is_superuser = null;
        Cookies.remove('is_superuser');

        state.first_name = null;
        Cookies.remove('first_name');

        state.last_name = null;
        Cookies.remove('last_name');

        state.email = null;
        Cookies.remove('email');

        state.phone_number = null;
        Cookies.remove('phone_number');

        state.is_stuff = null;
        Cookies.remove('is_stuff');

        state.is_manager = null;
        Cookies.remove('is_manager');

        state.is_engineer = null;
        Cookies.remove('is_engineer');

        state.is_fitter = null;
        Cookies.remove('is_fitter');

        state.abonent = null;
        Cookies.remove('abonent');


        state.date_joined = null;
        Cookies.remove('date_joined');
    }
};

const actions = {
    setAccount({ commit }, data) {
        commit('SET_ACCOUNT', data);
    },
    deleteData({ commit }) {
        commit('DELETE_DATA');
    }
};

const getters = {
    remember_account: state => state.remember_account,
    username: (state) => state.username,
    is_superuser: (state) => state.is_superuser === 'true',
    first_name: (state) => state.first_name,
    last_name: (state) => state.last_name,
    email: (state) => state.email,
    phone_number: (state) => state.phone_number,
    is_stuff: (state) => state.is_stuff === 'true',
    is_fitter: (state) => state.is_fitter === 'true',
    is_manager: (state) => state.is_manager === 'true',
    is_engineer: (state) => state.is_engineer === 'true',
    abonent: (state) => state.abonent,
    date_joined: (state) => state.date_joined
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
